/*eslint-disable*/
import React from "react";
import CustomDropDownPicker from "./CustomDropDownPicker"; // adjust path if needed

// Your internal property types
const propertyTypes = [
    { value: "Warehouse", label: "Warehouse" },
    { value: "Workshop", label: "Workshop" },
    { value: "Mini Factory", label: "Mini Factory" },
    { value: "Factory", label: "Factory" },
    { value: "Storage Unit", label: "Storage Unit" },
    { value: "Investment", label: "Investment" },
    { value: "Industrial Yard", label: "Industrial Yard" },
    { value: "Vacant Land", label: "Vacant Land" },
    { value: "Showroom", label: "Showroom" },
    { value: "Retail", label: "Retail" },
    { value: "Office", label: "Office" },
    { value: "Restaurant", label: "Restaurant" },
    { value: "Hotel", label: "Hotel" },
    { value: "Guesthouse", label: "Guesthouse" },
    { value: "Medical Suite", label: "Medical Suite" },
    { value: "Business Centre", label: "Business Centre" },
    { value: "Service Station", label: "Service Station" },
    { value: "Small Holding", label: "Small Holding" },
    { value: "Full Floor", label: "Full Floor" },
    { value: "Business", label: "Business" },
    { value: "Building", label: "Building" }
];

// Mapping to p24 property types
const propertyTypeMapping = {
    "warehouse": 12,
    "workshop": 12,
    "mini factory": 12,
    "factory": 12,
    "storage unit": 12,
    "investment": 11,
    "industrial yard": 12,
    "vacant land": 8,
    "showroom": 11,
    "retail": 11,
    "office": 11,
    "restaurant": 11,
    "hotel": 11,
    "guesthouse": 11,
    "medical suite": 11,
    "business centre": 11,
    "service station": 11,
    "small holding": 10,
    "full floor": 11,
    "business": 11,
    "building": 11
};

// Mapping to p24 property types
const propertyPPTypeMapping = {
    "warehouse": "Commercial",
    "workshop": "Commercial",
    "mini factory": "Commercial",
    "factory": "Commercial",
    "storage unit": "Commercial",
    "investment": "Commercial",
    "industrial yard": "Commercial",
    "vacant land": "Land",
    "showroom": "Commercial",
    "retail": "Commercial",
    "office": "Commercial",
    "restaurant": "Commercial",
    "hotel": "Commercial",
    "guesthouse": "Commercial",
    "medical suite": "Commercial",
    "business centre": "Commercial",
    "service station": "Commercial",
    "small holding": "Commercial",
    "full floor": "Commercial",
    "business": "Commercial",
    "building": "Commercial"
};

// Reusable component
const PropertyTypeDropdown = ({ value, onChange, placeholder = "Select a property type" }) => {
    const handleChange = (selectedProperty) => {

        const p24Value = propertyTypeMapping[selectedProperty] || null;
        const ppValue = propertyPPTypeMapping[selectedProperty] || null;

        if (onChange) {
            onChange(selectedProperty, p24Value, ppValue);
        }
    };

    return (
        <CustomDropDownPicker
            borderColor="grey"
            options={propertyTypes}
            required
            isMulti={false}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
        />
    );
};

export default PropertyTypeDropdown;
